/* eslint-disable react/no-array-index-key */
import { Row, Col } from 'react-bootstrap';
import ArticleWithShortDesc from '../../../../Components/articleWithShortDesc/ArticleWithShortDesc';
import {
  HeadingWithSpaceLarge,
  HeadingDescSmall
} from '../../../../Components/Headings';
import { AncerWithUnderlineSmall } from '../../../../Components/button';
import articleImageLarge from '../../../../assets/images/png/article-large.png';
import articleImage1 from '../../../../assets/images/png/article1.png';
import articleImage2 from '../../../../assets/images/png/article2.png';
import articleImage3 from '../../../../assets/images/png/article3.png';
import ArticleItemLists from '../../../../Components/articleItemLists/ArticleItemLists';
import { RightArrowWithBorder } from '../../../../Components/icons';
import './suggestedArticles.css';

const articlesData = [
  {
    image: articleImage1,
    status: [
      {
        statusText: 'Recomended',
        statusProgress: 'recomended'
      }
    ],
    topic: 'Make the Most of Your Safer-at-Home',
    topicDesc: '',
    btnText: 'read more',
    link: '/ArticleInnerPage'
  },
  {
    image: articleImage2,

    status: [
      {
        statusText: 'fact checked',
        statusProgress: 'fact'
      }
    ],
    topic: 'A Letter from the Editor',
    topicDesc: '',
    btnText: 'read more',
    link: '/ArticleInnerPage'
  },
  {
    image: articleImage3,

    status: [
      {
        statusText: '',
        statusProgress: ''
      }
    ],
    topic: 'Make the Most of Your Safer-at-Home',
    topicDesc: '',
    btnText: 'read more',
    link: '/ArticleInnerPage'
  }
];

function SuggestedArticles() {
  return (
    <section className="suggestedArticles article">
      <div className="sectionTop">
        <HeadingWithSpaceLarge text="SUGGESTED ARTICLES" />
        <div className="d-flex align-items-center">
          <RightArrowWithBorder />
          <AncerWithUnderlineSmall text="view all" />
        </div>
      </div>
      <Row>
        <Col md={10}>
          <div className="mb-3">
            <HeadingDescSmall text="Based on your results, stay connected and discover new ways to live an inspiring life through natural beauty, nutrition and diet, an active lifestyle, and better relationships." />
          </div>
        </Col>
        <Col md={7} className="pe-lg-0">
          <ArticleWithShortDesc
            image={articleImageLarge}
            status={[
              { statusProgress: 'verified', statusText: 'Evidence Based' }
            ]}
            statusText="Evidence Based"
            statusProgress="verified"
            topic="Make the Most of Your Safer-at-Home Summer"
            desc="As we face continued social distancing and safer-at-home guidelines, here are some creative ways to keep your family active"
            btnText="read more"
          />
        </Col>
        <Col md={5}>
          {articlesData.map((article, index) => {
            const { image, topic, topicDesc, btnText, link } = article;
            return (
              <ArticleItemLists
                key={index}
                status={article.status}
                leftCol={5}
                rightCol={7}
                image={image}
                heading={topic}
                desc={topicDesc}
                btnText={btnText}
                link={link}
              />
            );
          })}
        </Col>
      </Row>
    </section>
  );
}

export default SuggestedArticles;
